import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "CampusExit";

export const getExitRequestsUrl = (filter) =>
	`${baseUrl}/request?${generateUrlParams(filter)}`;
export const getStudentExitRequestsUrl = (filter) =>
	`${baseUrl}/student-requests?${generateUrlParams(filter)}`;
export const getExitRequestUrl = (exitRequestId) =>
	`${baseUrl}/${exitRequestId}`;
export const csoApprovalUrl = () => `${baseUrl}/cso-approval`;
export const createExitRequestUrl = () => `${baseUrl}/create`;

export const parentApprovalUrl = () => `${baseUrl}/parent-approval`;
export const getParentExitRequestsUrl = (filter) =>
	`${baseUrl}/parent-requests?${generateUrlParams(filter)}`;
export const getParentExitRequestUrl = (exitRequestId, parentEmail) =>
	`${baseUrl}/parent-request/${exitRequestId}?${generateUrlParams({
		parentEmail
	})}`;

export const getGateVerificationDetailsUrl = (exitCode) =>
	`${baseUrl}/verify/${exitCode}`;
